module.exports = __webpack_public_path__ + "static/media/left-arrow.aaa2bc48.svg";